DJ.addBehavior('accordion-opener', '.accordion-opener', {
  attach: function(context, settings, behavior) {
    var $holder = jQuery(this);
    var flag = true;

    // Mega-menu: sur desktop, on ne doit pas ouvrir le sous-menu à gauche
    // via l'accordion. On laisse ce comportement inchangé sur mobile.
    var isMegaMenuDesktop = window.innerWidth > 974 && $holder.closest('.header-drop-down-left').length;

    if (isMegaMenuDesktop) {
      $holder.removeClass('opened');
      var $slide = $holder.find('.slide');
      if ($slide.length) {
        $slide.hide();
        $slide.addClass('js-slide-hidden');
      }
      var $button = $holder.find('.opener button, .opener .btn');
      if ($button.length && $button.attr('aria-expanded') !== undefined) {
        $button.attr('aria-expanded', 'false');
      }
      return;
    }

    if ($holder.hasClass('alphabet')) {
      flag = false
    }

    $holder.openClose({
      activeClass: 'opened',
      opener: '.opener',
      slider: '.slide',
      animSpeed: 200,
      addClassBeforeAnimation: true,
      hideOnClickOutside: flag,
      effect: 'slide'
    });

    // Mise à jour de aria-expanded lors de l'ouverture/fermeture
    var $button = $holder.find('.opener button, .opener .btn');
    if ($button.length && $button.attr('aria-expanded') !== undefined) {
      // Observer les changements de classe sur le holder
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'class') {
            var isOpened = $holder.hasClass('opened');
            $button.attr('aria-expanded', isOpened ? 'true' : 'false');
          }
        });
      });

      observer.observe($holder[0], {
        attributes: true,
        attributeFilter: ['class']
      });
    }

  },

  detach: function(context, settings) {}
});
